"use client"

import Link from "next/link"
import { Monitor } from "lucide-react"

export function MobileRestriction() {
    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white px-6 text-center">
            <div className="max-w-md space-y-8">
                <div className="flex justify-center">
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-50 text-blue-600">
                        <Monitor className="h-8 w-8" />
                    </div>
                </div>
                
                <div className="space-y-4">
                    <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
                        Desktop Experience Only
                    </h1>
                    <p className="text-base text-slate-500 leading-relaxed">
                        For the best experience, please use Deckwale on a desktop. Our AI presentation and documents building tools are designed for larger screens.
                    </p>
                </div>

                <div className="pt-4">
                    <Link 
                        href="/discover"
                        className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-8 py-3.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 transition-all active:scale-[0.98]"
                    >
                        Explore Deckwale
                    </Link>
                </div>
                
                <p className="text-xs text-slate-600">
                    Discover how we use AI to build professional presentations.
                </p>
            </div>
        </div>
    )
}
